


<template>
  
  <div 
    v-if="showPediatriaNeurologico" 
    style="border: 1px solid #c9c9c9; border-radius: 5px;"
    class="p-1 my-2"
  >

    <h6 class="text-center">Neurologico</h6>

    <div class="row mb-1 d-flex align-items-center">

      <div class="col-3">Test Denver:</div>
      <b-form-textarea 
        v-model="neurologico.testDenver"
        class="col-11 mx-1" 
        rows="4"
      />
    </div>


    <div class="my-3">

      <h6>Exploración Neurológica : Nivel de alerta, tono, postura y movilidad</h6>

      <b-row class="my-2">
        <b-col>
          <b-form-checkbox-group
            :options="exploracionOpts"
            plain
            size="lg"
            v-model="neurologico.exploracionChecked"
          />
        </b-col>
      </b-row>

      <div
        v-for="(item) in neurologico.exploracionItems"
        :key="item.value"
        class="row my-2 d-flex align-items-center"
      >
        <label class="col-12">{{ item.text }}</label>

        <b-form-checkbox
          switch
          v-model="item.presente"
          class="col-5 ml-2"
        >
          {{ item.presente ? 'Presente' : 'Ausente( Deficit Neurologico)' }}
        </b-form-checkbox>

        <b-form-input
          v-if="!item.presente"
          class="col-6"
          v-model="item.inputText"
        />

      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ESPECIALIDAD } from '@/shared/constants';

export default {


  data() {
    return {

      neurologico:{
        tipo               : 'pediatria',
        descripcion        : null,
        testDenver         : null,
        exploracionChecked : [],
        exploracionItems   : [],
      },


      exploracionOpts:[
        { value: "reflejos_osteotendinosos", text: "Reflejos osteotendinosos" },
        { value: "reflejos_arcaicos",        text: "Reflejos arcaicos o primitivos" },
        { value: "reflejos_glabelar",        text: "Reflejos glabelar" },
        { value: "reflejos_de_buscaqueda",   text: "Reflejos de búsqueda" },
        { value: "reflejos_de_succión",      text: "Reflejos de succión" },
        { value: "reflejos_de_presion",      text: "Reflejos de presion" },
        { value: "reflejos_tonicos",         text: "Reflejos tónico asimétrico del cuello" },
        { value: "reflejos_de_extensión",    text: "Reflejos de extensión cruzada" },
        { value: "reflejos_de_colocación",   text: "Reflejos de colocación" },
        { value: "reflejos_de_marcha",       text: "Reflejo de la marcha" },
      ],
    };
  },


  computed:{

    ...mapState({
      stExamenFisico : state => state.atencionCita.anamnesis?.examenFisico,
      stDataDoctor   : state => state.atencionCita.dataCita?.doctor,
    }),

    showPediatriaNeurologico() {
      if(!this.stExamenFisico) return false;
      const neuroActivo = this.stExamenFisico.items.some( i => i.value === "neurológico")
      return neuroActivo && this.esPediatria;
    },


    esPediatria() {
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.PEDIATRA;
    }

  },


  watch:{

    'neurologico.exploracionChecked': {
      deep: true,
      handler() {

        let  items = this.neurologico.exploracionItems;
        const checkeds = this.neurologico.exploracionChecked;

        items = items.filter(
          item => checkeds.includes( item.value )
        );

        checkeds.forEach( id => {
          if( !items.some( item => item.value === id )){

            const newItem = this.exploracionOpts.find( item => item.value === id ); 

            this.neurologico.exploracionItems.push({
              value: newItem.value,
              text: newItem.text,
              inputText: '',
              presente:true
            });
          }
        })
      }
    },


    neurologico: {
      deep: true,
      handler(newValue) {
        const examenes = this.stExamenFisico.items;
        const index = examenes.findIndex( item => item.value === "neurológico" );
        if(index !== -1) {
          examenes[index].dataJson = newValue;
        }
      }
    }
  }
}
</script>
